import { _ as __assign } from './_tslib-ff3a08af.js';
import { jsx } from 'react/jsx-runtime';
import SvgIcon from '@material-ui/core/SvgIcon';
import { createElement } from 'react';

var _path;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }return n;
  }, _extends.apply(null, arguments);
}
function SvgCaretDown(props) {
  return (/*#__PURE__*/createElement("svg", _extends({
      width: 12,
      height: 8,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), _path || (_path = /*#__PURE__*/createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.906.576A1.002 1.002 0 0011 0H1a1.001 1.001 0 00-.768 1.64l5 6a1 1 0 001.536 0l5-6a1 1 0 00.138-1.064z",
      fill: "#353E53"
    })))
  );
}

var CaretDownIcon = function (props) {
  return jsx(SvgIcon, __assign({}, props, { component: SvgCaretDown, viewBox: '0 0 12 8' }));
};

export { CaretDownIcon as C };
